import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgVideo32 = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 32 32"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <defs>
        <path
          id="video-32_svg__a"
          d="M26.659 11.553a1 1 0 0 1 .105.447v7.764a1 1 0 0 1-1.447.895L22 19v-1.118l3.764 1.882V12L22 13.882v-1.119l3.317-1.657a1 1 0 0 1 1.342.447M20 10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1zm0 1H6v10h14zm-9.024 1.5c.103 0 .204.02.299.058l.091.044 4.799 2.695a.809.809 0 0 1 .094 1.344l-.093.062-4.8 2.695a.8.8 0 0 1-1.185-.604l-.006-.1v-5.388c0-.443.357-.806.801-.806m.199 1.141v4.717l4.2-2.358z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="video-32_svg__b" fill="#fff">
          <use xlinkHref="#video-32_svg__a" />
        </mask>
        <use xlinkHref="#video-32_svg__a" fill="#000" fillRule="nonzero" />
        <g fill="#262729" mask="url(#video-32_svg__b)">
          <path d="M0 0h32v32H0z" />
        </g>
      </g>
    </SvgIcon>
  );
};
const Memo = memo(SvgVideo32);
export default Memo;
